import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { Field } from '../../../common/types/form';
import { StatisticRecord } from '../../../common/types/statistics/statistics';

type Props<T> = {
  fieldKey: string;
  fields: Field<T>[];
  statistic: StatisticRecord;
};

function OptionStatistic<T>({ fieldKey, fields, statistic }: Props<T>) {
  const field = fields.find((field) => field.key === fieldKey);

  if (field == null || (field.fieldTypes !== 'select' && field.fieldTypes !== 'checkboxSelect')) {
    return null;
  }

  return (
    <Stack my={2}>
      {field.label != null && <Typography fontWeight='bold'>{field.label}</Typography>}
      {Object.keys(statistic).map((statisticKey) => {
        if (statisticKey === 'notSpecified') {
          return <Typography key={statisticKey}>Keine Angabe: {statistic[statisticKey]}</Typography>;
        }
        const option = field.options.find((option) => option.value === statisticKey);
        return option == null ? null : (
          <Typography key={statisticKey}>
            {option.label}: {statistic[statisticKey]}
          </Typography>
        );
      })}
    </Stack>
  );
}

export default OptionStatistic;
